import Vue, { VueConstructor } from "vue";

import LoadingService from "@/services/loading/loading.service";

Vue.use((_Vue: VueConstructor) => {
  _Vue.prototype.$loading = LoadingService;
});
